import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-branding-settings',
    templateUrl: './branding-settings.component.html',
    standalone: false
})
export class BrandingSettingsComponent {
  @Input() activeTabIndex: number = 0;
  @Output() activeTabIndexChange = new EventEmitter<number>();

  onTabChange(index: string | number | undefined): void {
    if (index === undefined) {
      return;
    }

    const numericIndex = Number(index);

    this.activeTabIndex = numericIndex;
    this.activeTabIndexChange.emit(numericIndex);
  }
}
